class Form {
	constructor(form) {
		this.form = form;
		this.feedback = form.querySelector('[data-form-feedback]');
		this.form.addEventListener('submit', this.submit.bind(this));
		this.timer = null;
	}

	resetFeedback() {
		window.clearTimeout(this.timer);
		this.feedback.innerHTML = '';
		this.feedback.classList.remove('is-success', 'is-error', 'is-active');
	}

	addFeedback(message, classes) {
		this.feedback.classList.add(...classes);
		this.feedback.innerHTML = message;
	}

	displaySuccess(data) {
		if (!data.success) {
			this.displayFailure(data?.data?.message);
			return;
		}

		this.resetFeedback();
		this.form.reset();
		this.addFeedback(data.data.message, ['is-success', 'is-active']);

		this.timer = window.setTimeout(() => {
			this.feedback.classList.remove('is-active');
		}, 10000);
	}

	displayFailure(error) {
		error = error ?? 'Someting went wrong';

		this.resetFeedback();
		this.addFeedback(error, ['is-error', 'is-active']);
	}

	submit(e) {
		e.preventDefault();

		if (this.isSubmitting) {
			return; // Prevent multiple submit requests
		}

		this.isSubmitting = true;

		fetch(this.form.action, {
			method: 'POST',
			body: new FormData(this.form),
		})
			.then(response => response.json())
			.then(data => this.displaySuccess(data))
			.catch(error => this.displayFailure(error))
			.finally(() => (this.isSubmitting = false));
	}
}

export default class Forms {
	constructor() {
		document.addEventListener('bless', ({ detail }) => {
			this.init(detail.next.container);
		});
	}

	init(container) {
		this.container = container;
		this.forms = [];

		const forms = this.container.querySelectorAll('[data-form]');

		forms.forEach(form => {
			this.forms.push(new Form(form));
		});
	}
}
